import requester from '@/utils/request'
export const messageService = {
  // 左侧私信用户列表
  getChatUserList: (data: any, headers?: any) => requester.post('/chat/v1/list', data, headers),
  // 私信消息内容列表
  getMessageList: (data: any, headers?: any) =>
    requester.post('/chat/message/v1/list', data, headers),
  // 发送私信消息
  sendMessage: (data: any, headers?: any) => requester.post('/chat/message/v1/send', data, headers),
  // 查看通知列表
  notificationList: (data: any, headers?: any) =>
    requester.post('/event/notification/list', data, headers),
  // 通知未读计数
  notificationStatistic: (data?: any, headers?: any) =>
    requester.get('/event/notification/statistic/unread', data, headers),
  // 喜欢消息
  favoriteMessage: (data: any, headers?: any) =>
    requester.post('/chat/message/v1/favorite', data, headers),
  // 撤回消息
  revokeMsg: (data: any, headers?: any) => requester.post('/chat-msg/v1/revokeMsg', data, headers),
  // 创作者群发付费消息
  creatorGroupSend: (data: any, headers?: any) =>
    requester.post('/chat/message/v1/creator/group/send', data, headers),
  // 获取当前用户聊天聊表用户信息
  getChattingUser: (data: any, headers?: any) =>
    requester.post('/chat/v1/list/chatting/user', data, headers),
  // 解锁消息媒体内容
  unlockMessageMedia: (data: any, headers?: any) =>
    requester.post('/chat/message/v1/unlock/message/media', data, headers),
  // 获取我发布过的媒体资源（图片、视频）
  getMyMediaList: (data: any, headers?: any) =>
    requester.post('/blog/v1/queryMyMediaList', data, headers),
  // 查询自定义欢迎语
  queryWelcomeMsg: () => requester.post('/chat/creator-welcome-msg/getWelcomeMsg', {}),
  // 设置自定义欢迎语
  setWelcomeMsg: (data: any) => requester.post('/chat/creator-welcome-msg/setWelcomeMsg', data),
  // 获取我的媒体信息（Gallery）
  getGalleryList: (data: any) => requester.post('/chat-msg/v1/queryCommonGallery', data),
  // 获取全部聊天粉丝数、关注粉丝数、订阅粉丝数
  queryChatFansNum: () => requester.post('/chat-msg/v1/queryChatFansNum', {}),
  // agoraChat：token
  chatToken: () => requester.post('/chat-msg/v1/queryToken'),
  // agoraChat：左侧私信用户列表
  getAgoraChatUserList: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/queryChatPairList', data, headers),
  // agoraChat：私信消息内容列表
  getAgoraChatMessageList: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/queryChatMsgList', data, headers),
  // agoraChat：上报聊天消息(免费消息)
  reportAgoraChatMessage: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/reportChatMsg', data, headers),
  // agoraChat：上报错误信息
  reportErrorAgoraChatMessage: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/reportErrorMsg', data, headers),
  // agoraChat：创作者发送付费私信消息
  sendPaidMessage: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/sendPaidMessage', data, headers),
  // agoraChat：未读消息总数
  unreadChatNum: () => requester.post('/chat-msg/v1/queryMyUnreadChatNum'),
  // agoraChat：点赞消息
  favoriteAgoraMessage: (data: any, headers?: any) =>
    requester.post('/chat-msg/v1/favorite', data, headers),
  // agoraChat：设置某个会话消息已读
  setConversationRead: (data: any) => requester.post('/chat-msg/v1/setChatRead', data),
  // 获取我发过的所有的媒体信息（图片、视频）
  queryMySentMediaList: (data: any) => requester.post('/chat-msg/v1/queryMySentMediaList', data),
  // 获取我发过的所有的媒体总数量（图片、视频
  queryMySentMediaCount: () => requester.post('/chat-msg/v1/queryMySentMediaNum'),
  // 搜索聊天好友
  queryFriend: (data: any) => requester.post('/chat-msg/v1/friend/query', data),
  // 开启付费粉丝才能给创作者发消息
  setOperateType: (data: any) => requester.post('/seller/creator-business-switch/operate', data),
  // 查询开启付费粉丝才能给创作者发消息的状态
  queryOpenStatus: (data: any) =>
    requester.post('/seller/creator-business-switch/queryOpenStatus', data),
  // 手动发送消息 notification
  queryOpennotificationTriggerStatus: (data: any) =>
    requester.post('/seller/fcm/v1/notification/trigger', data),
  // 绑定当前用户和FCM Token关系 notification
  userTokenBind: (data: any) => requester.post('/seller/fcm/v1/user-token/bind', data),
  // 取消绑定当前用户和FCM Token关系 notification
  userTokenUnbind: (data: any) => requester.post('/seller/fcm/v1/user-token/unbind', data),
  // 设置配置
  customConfigSet: (data: any) => requester.post('/custom-config/v1/set', data),
  // 查询配置
  customConfigQuery: (data: any) => requester.post('/custom-config/v1/query', data),
  // 查询当前用户在设备上和FCM Token关系
  userTokenQuery: (data: any) => requester.post('/seller/fcm/v1/user-token/query', data),
  // 获取全部群发消息
  queryMassSendMsgList: (data: any) => requester.post('/massSendMsg/queryList', data),
  // 已撤回的群发消息
  queryRevokeList: (data: any) => requester.post('/massSendMsg/queryRevokeList', data),
  // 撤回一个群发消息
  revokeMassMsg: (data: any) => requester.post('/massSendMsg/revokeMassMsg', data),
  // 修改聊天级别AI助手开启状态
  changeAiStatus: (data: any) =>
    requester.post('/ai-assistant-configuration/v1/chat-friend/ai-assistant/status/update', data),
}
